export class WorkOrderEditTemplateConfiguration {

  WorkOrder: { Oid: number } | any | null = null;
  visible: boolean = false;
  
  /** 
   * Se true, mostra l'editor solo quando è un preventivo (quotation).
   * Se false, mostra l'editor sia per quotation che per work order normali.
   * Default: true (comportamento attuale - solo quotation)
   */
  showOnlyInQuotation: boolean = true;

  private constructor() {
  }

  public static create = () => new WorkOrderEditTemplateConfiguration();

  setWorkOrderOid(value: number | null): this {
    this.WorkOrder = value ? {Oid: value} : null;
    return this;
  }

  /**
   * Imposta se mostrare l'editor solo nei preventivi o anche negli ordini di lavoro.
   * @param value true = solo quotation (default), false = sia quotation che work order
   */
  setShowOnlyInQuotation(value: boolean): this {
    this.showOnlyInQuotation = value;
    return this;
  }


}
